<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Customers List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="customers"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <template v-slot:item.Balance="{ item }">
                <span>{{item.Balance}}</span>
              </template>
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/statement/customer/${item.id}`" icon>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <!-- customers dialog -->
          <v-dialog v-model="customersDialog" max-width="650px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Import Customers</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="customersDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="6">
                      <v-file-input
                        name="productExcelFile"
                        v-model="excelFile"
                        label="Browse Excel Sheet"
                        outlined
                        dense
                      ></v-file-input>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="accent" @click="uploadExcel" :loading="loader">
                        <v-icon left>mdi-upload</v-icon>Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    customersDialog: false,
    loader: false,
    zeroValue: 0,
    pageItems: 100,
    headers: [
      { text: "Code", value: "CardCode" },
      { text: "Customer Name", value: "Name" },
      { text: "Balance", value: "Balance" },
      { text: "Action", value: "action" },
    ],
    customers: [],
    excelFile: null,
  }),
  methods: {
    uploadExcel() {
      const data = new FormData();
      data.append("customersData", this.excelFile);
      // send request
      this.loader = true;
      const url = "/import-customers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show(
              "Customers imported successfully",
              "green"
            );
            self.loader = false;
            self.excelFile = null;
            self.customersDialog = false;
            self.getCustomers();
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
      // end
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCustomers();
  },
};
</script>